import { render } from "./ClientImport.vue?vue&type=template&id=3a65e6a0"
import script from "./ClientImport.vue?vue&type=script&lang=js"
export * from "./ClientImport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__